import React from 'react';

/**
 * RONR: the chair, if a member, may vote whenever their vote would affect the
 * result — including to make or break a tie. Surfaced only when the tally is tied.
 */
export default function TieBreakModal({ open, hasCounts = true, yes = 0, no = 0, onCancel, onResolve }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/40 p-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="tie-break-title"
        className="w-full max-w-sm overflow-hidden rounded-2xl border border-pp-line bg-pp-surface shadow-pp"
      >
        <div className="border-b border-pp-line px-5 py-4">
          <h2 id="tie-break-title" className="text-lg font-semibold tracking-tight text-pp-ink">
            The vote is tied
          </h2>
          <p className="mt-1 text-sm text-pp-muted">
            {hasCounts
              ? `${yes}–${no}. As chair, you may cast a vote to make or break the tie.`
              : "The chair perceives the vote is evenly divided. As chair, you may cast a vote to make or break the tie."}
          </p>
        </div>
        <div className="space-y-2 px-5 py-4">
          <button
            type="button"
            onClick={() => onResolve('yes')}
            className="w-full rounded-xl bg-pp-ink px-4 py-2.5 text-sm font-semibold text-pp-surface hover:opacity-90"
          >
            Vote Aye — motion adopts
          </button>
          <button
            type="button"
            onClick={() => onResolve('no')}
            className="w-full rounded-xl border border-pp-line bg-pp-paper px-4 py-2.5 text-sm font-medium text-pp-ink hover:bg-pp-surface"
          >
            Vote No — motion fails
          </button>
          <button
            type="button"
            onClick={() => onResolve('decline')}
            className="w-full rounded-xl border border-pp-line px-4 py-2.5 text-sm text-pp-muted hover:bg-pp-paper"
          >
            Decline to vote — tie fails
          </button>
        </div>
        <div className="flex justify-end gap-2 border-t border-pp-line px-5 py-3">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-xl px-4 py-2 text-sm font-medium text-pp-muted hover:bg-pp-paper"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
